import React from 'react'
import GCurrency from 'tennders-market/common/components/element/GCurrency'

const MultipleSalesInvoiceOutput = ({
  totalAmountOnInvoice,
  totalExtraCosts,
  calculateTotalDiscount,
  totalDiscount,
  totalEndAmountToPay,
  totalVatAmount
}) => (
  <div className="w-25">
    <table className="w-100">
      <tr>
        <td className="text-right va-top ls-1 text-14 p-4">Subtotal:</td>
        <td className="text-right bold"> {GCurrency({ value: totalAmountOnInvoice + totalExtraCosts })} </td>
      </tr>
      <tr>
        <td className="text-right va-top ls-1 text-14 p-4">Discount:</td>
        <td className="text-right color-red bold">{GCurrency({ value: totalDiscount * -1 })} </td>
      </tr>
      <tr>
        <td className="text-right va-top ls-1 text-14 p-4">Vat:</td>
        <td className="text-right bold"> {GCurrency({ value: totalVatAmount })} </td>
      </tr>

      <tr>
        <td className="text-right va-top text-uppercase ls-1 text-14 p-4">Grand Total :</td>
        <td className="text-right bold text-18">{
          GCurrency({ value: totalEndAmountToPay })
        }
        </td>
      </tr>
    </table>
  </div>
)

export default React.memo(MultipleSalesInvoiceOutput)
